'use client'
import { ApolloClient, from } from '@apollo/client'
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev'
import { removeTypenameFromVariables } from '@apollo/client/link/remove-typename'
import { envs } from '@config/envs'

import { splitLink } from './apollo-link'
import { cache } from './cache'

const removeTypenameLink = removeTypenameFromVariables()

if (envs.isDevelopment) {
  loadDevMessages()
  loadErrorMessages()
}

export const apolloClient = new ApolloClient({
  link: from([removeTypenameLink, splitLink]),
  cache,
})
